export const ApiUrls = {
  activation: {
    getActivationInfo: "/api/GetActivationDetails",
    postAccountActivate: "/api/ActivateUserAccount",
  }
}